import React from 'react';
import _ from 'lodash';

import {
  FormElement,
  FormListItem,
  FormListSubHeader,
  TextInput,
  FormList,
} from './CommonFormComponents';
import { PostalCode } from './PostalCode';
import { PREFECTURE_GROUPS } from '../utilities/constants';
import { ArrowDownIcon } from './icons/ArrowDownIcon';
import { Tel } from './Tel';
import { messageUtility } from '../utilities/messageUtility';

export const PartnerCompanyBranchForm = ({
  values,
  messages,
  readOnly,
  events,
}) => {
  const title = readOnly ? '支店　基本情報' : '基本情報';

  return (
    <FormList>
      <React.Fragment>
        <FormListSubHeader title={title} noMarginTop={!readOnly} />
        <FormListItem label='支店名' safetyDocItem={true} required={!readOnly}>
          <FormElement validate={_.get(messages, 'name')}>
            <TextInput
              id='name'
              type='text'
              name='name'
              disabled={readOnly}
              value={_.get(values, 'name')}
              onChange={e => events.setValue('name', e.target.value)}
              onBlur={events.validate ? e => events.validate(e) : null}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='支店名ふりがな' required={!readOnly}>
          <FormElement validate={_.get(messages, 'kana')}>
            <TextInput
              id='kana'
              type='text'
              name='kana'
              disabled={readOnly}
              value={_.get(values, 'kana', '')}
              onChange={e => events.setValue('kana', e.target.value)}
              onBlur={events.validate ? e => events.validate(e) : null}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='郵便番号' required={!readOnly}>
          <PostalCode
            value={_.get(values, 'postal_code')}
            handleOnChange={events.setValue}
            setKey='postal_code'
            readOnly={readOnly}
            error={_.get(messages, 'postal_code')}
            validate={events.validate}
          />
        </FormListItem>
        <FormListItem label='都道府県' required={!readOnly}>
          <FormElement validate={_.get(messages, 'prefectures_code_id')}>
            <select
              name='prefectures_code_id'
              disabled={readOnly}
              value={_.get(values, 'prefectures_code_id', '')}
              onChange={e =>
                events.setValue('prefectures_code_id', e.target.value)
              }
              onBlur={events.validate}
            >
              <option value=''>{readOnly ? '' : '選択してください'}</option>
              {_.map(PREFECTURE_GROUPS, (region, index) => (
                <optgroup key={index} label={region.label}>
                  {_.map(region.prefectures, prefecture => (
                    <option key={prefecture.id} value={prefecture.id}>
                      {prefecture.name}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </FormElement>
        </FormListItem>
        <FormListItem label='市区町村' required={!readOnly}>
          <FormElement validate={_.get(messages, 'city_name')}>
            <TextInput
              type='text'
              name='city_name'
              disabled={readOnly}
              value={_.get(values, 'city_name', '')}
              placeholder={messageUtility.getMessage('I-000-190')}
              onChange={e => events.setValue('city_name', e.target.value)}
              onBlur={events.validate ? e => events.validate(e) : null}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label={messageUtility.getMessage('I-000-188')}>
          <FormElement validate={_.get(messages, 'street_number')}>
            <TextInput
              type='text'
              name='street_number'
              disabled={readOnly}
              value={_.get(values, 'street_number', '')}
              placeholder={messageUtility.getMessage('I-000-191')}
              onChange={e => events.setValue('street_number', e.target.value)}
              onBlur={e => events.validate(e)}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='建物名・部屋番号等'>
          <FormElement validate={_.get(messages, 'building_name')}>
            <TextInput
              type='text'
              name='building_name'
              disabled={readOnly}
              value={_.get(values, 'building_name', '')}
              placeholder='（例）赤坂ビルディング'
              onChange={e => events.setValue('building_name', e.target.value)}
              onBlur={events.validate ? e => events.validate(e) : null}
              maxLength={512}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='電話番号' required={!readOnly}>
          <Tel
            value={_.get(values, 'tel', '')}
            handleOnChange={events.setValue}
            setKey='tel'
            readOnly={readOnly}
            error={_.get(messages, 'tel')}
            validate={e => events.validate(e, 'tel')}
            placeholder=''
          />
        </FormListItem>
        <FormListItem label='FAX番号'>
          <Tel
            value={_.get(values, 'fax', '')}
            readOnly={readOnly}
            handleOnChange={events.setValue}
            setKey='fax'
            error={_.get(messages, 'fax')}
            validate={e => events.validate(e, 'fax')}
            placeholder=''
          />
        </FormListItem>
      </React.Fragment>
    </FormList>
  );
};



// WEBPACK FOOTER //
// ./src/components/PartnerCompanyBranchForm.jsx